import React from 'react';

class WorkVisualsInformations extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        if(this.props.details !== nextProps.details) {
            return true;
        }
        
        return false;
    }

    render() {
        return (
            <ul className={`work-informations ${this.props.side} no-style`}>
                {this.props.details && this.props.details.map((detail, index) => {
                        return (
                            <li key={index}>
                                <span className="red barlow-me">{detail.title.split('\n').map((item, i) => <span key={`title-${i}`}>{item}</span>)}</span>
                                {detail.label.split('\n').map((item, i) => <span key={`label-${i}`}>{item}</span>)}
                            </li>
                        );
                    })
                }
            </ul>
        );
    }
};

export default WorkVisualsInformations;


// WEBPACK FOOTER //
// ./src/components/WorkVisualsInformations.js